import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  lang: "en",
  dir: "ltr",
  "data-mode": "light",
  class: "scroll-smooths group",
  "data-theme-color": "violet"
}
const _hoisted_2 = { class: "bg-white dark:bg-neutral-800" }
const _hoisted_3 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookieConcentBanner = _resolveComponent("CookieConcentBanner")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("html", _hoisted_1, [
    _createElementVNode("head", null, [
      _cache[0] || (_cache[0] = _createStaticVNode("<meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1, shrink-to-fit=no\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><link rel=\"shortcut icon\" href=\"./assets/images/favicon.ico\"><link type=\"css\" rel=\"stylesheet\" href=\"./assets/css/icons.css\"><link type=\"css\" rel=\"stylesheet\" href=\"./assets/css/tailwind.css\"><link type=\"css\" rel=\"stylesheet\" href=\"./assets/libs/choices.js/public/assets/styles/choices.min.css\">", 7)),
      _createVNode(_component_CookieConcentBanner)
    ]),
    _createElementVNode("body", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Navigation),
        _createVNode(_component_router_view),
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}